import GridContainer from '@deltek/specification-client/core/Surfaces/GridContainer'
import GridItem from '@deltek/specification-client/core/Surfaces/GridItem'
import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Theme, makeStyles } from '@material-ui/core/styles'
import ToggleSwitch from 'components/ToggleSwitch/ToggleSwitch'
import React from 'react'

const useShowHideBarStyles = makeStyles((theme: Theme) => ({
    label: {
        fontSize: pxToRem(14),
        color: '#04325B',
        fontWeight: 500,
        padding: '10px 8px',
        paddingRight: theme.spacing(0),
    },
    padded: {
        paddingTop: theme.spacing(0.4),
        paddingRight: theme.spacing(1),
    },
    fab: {
        margin: 'auto',
        boxShadow: '0px 2px 10px -5px',
        background: theme.palette.common.white,
        border: `1px solid ${theme.palette.grey[400]}`,
    },
}))

export type ToggleHandlerType = 'property' | 'paragraph' | 'notes' | 'shared'
export interface SidebarToggles {
    toggleHandler: (name: ToggleHandlerType) => void
    isNotesVisible: boolean
    isPropertyVisible: boolean
    isSharedVisible: boolean
    elementType: string
    contentTeamFromStudioPage?: boolean
    isOMWorkspace?: boolean
}

const SidebarToggles: React.FC<SidebarToggles> = ({
    toggleHandler,
    isNotesVisible,
    isPropertyVisible,
    isSharedVisible,
    elementType,
    contentTeamFromStudioPage,
    isOMWorkspace,
}) => {
    const classes = useShowHideBarStyles()

    const onToggle = (name: ToggleHandlerType) => () => toggleHandler(name)

    return (
        <GridContainer
            direction="column"
            data-testid="sidebarToggles"
            justifyContent="space-between"
        >
            {!isOMWorkspace ? (
                <GridItem data-testid="propertiesToggle">
                    <GridContainer justifyContent="space-between">
                        <GridItem className={classes.label}>
                            <span>Show Inactive Content</span>
                        </GridItem>

                        <GridItem
                            className={classes.padded}
                            data-testid="hiddenSwitch"
                        >
                            <ToggleSwitch
                                checked={isPropertyVisible}
                                onChange={onToggle('property')}
                                size={'small'}
                                disabled={contentTeamFromStudioPage}
                            />
                        </GridItem>
                    </GridContainer>
                </GridItem>
            ) : null}

            <GridItem data-testid="notesToggle">
                <GridContainer justifyContent="space-between">
                    <GridItem className={classes.label}>
                        <span>Show Notes to Specifier</span>
                    </GridItem>
                    <GridItem
                        className={classes.padded}
                        data-testid="notesSwitch"
                    >
                        <ToggleSwitch
                            checked={isNotesVisible}
                            onChange={onToggle('notes')}
                            size={'small'}
                        />
                    </GridItem>
                </GridContainer>
            </GridItem>
            {elementType === 'PRODUCTTYPE' && !contentTeamFromStudioPage && (
                <GridItem data-testid="sharedToggle">
                    <GridContainer justifyContent="space-between">
                        <GridItem className={classes.label}>
                            <span>Show Shared Properties</span>
                        </GridItem>
                        <GridItem
                            className={classes.padded}
                            data-testid="sharedSwitch"
                        >
                            <ToggleSwitch
                                checked={isSharedVisible}
                                onChange={onToggle('shared')}
                                size={'small'}
                            />
                        </GridItem>
                    </GridContainer>
                </GridItem>
            )}
        </GridContainer>
    )
}

export default SidebarToggles
